import React, { FC } from 'react';
import ArticleContent from '../../../components/articles/articleContent';
import { Container } from '../../../components/base/grid';
import pageWrapper from '../../../hoc/pageWrapper';
import IPageViewModel from '../../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	page: IPageViewModel;
	componentId: number;
}

const Article: FC<Props> = ({ page }) => {
	return (
		<Container>
			{/* <Breadcrumbs pageId={page.Id} /> */}
			<ArticleContent page={page} />
		</Container>
	);
};

export default pageWrapper(Article);
